import { DocumentoComercialValidacionDtoProps } from "api/DTOs/DocumentoComercialValidacionDto"

export const documentoComercialValidacionAdapter = (
  documento: DocumentoComercialValidacionDtoProps
) => {
  return {
    id: documento.id,
    fechaEmision: documento.fechaEmision,
    importe: documento.importe,
    nifLibrador: documento.nifLibrador,
    numero: documento.numero,
    numFirmados: documento.numFirmados,
    numFirmas: documento.numFirmas,
    razonSocialLibrador: documento.razonSocialLibrador,
    serie: documento.serie,
    tipoDocumento: documento.tipoDocumento,
    tipoDocumentoComercial: documento.tipoDocumentoComercial,
  }
}
